export default "__VITE_ASSET__BbayN3B7__"